export default __webpack_public_path__ + "static/media/Raleway-Bold.d1a96e2a.ttf";